import React, {useEffect, useRef, useState} from "react";
import {Grid, Typography} from "@mui/material";
import useChallengeFinalStyle from "../../styles/challengeUntold/challengeFinal";
import kozel_meeet from "../../assets/images/kozel_meet/meet_logo.png";
import clsx from "clsx";
import TeaserFrame2 from "../TeaserFrame2";
import theme from "../../styles/themes/default";
import image_mixologist from '../../assets/images/my_group/image_mixologist.png'
import useActivity from "../../hooks/useActivity";
import Confetti from 'react-confetti';

const ChallengeFinal: React.FC = () => {
    const componentRef = useRef<HTMLDivElement>(null);
    const styles = useChallengeFinalStyle();
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

    const {registerActivity} = useActivity();

    useEffect(() => {
        if (componentRef.current) {
            const { width, height } = componentRef.current.getBoundingClientRect();
            setDimensions({ width, height });
        }
        registerActivity({
            name: 'UNTOLD_CHALLENGE_FINAL',
            payload: {},
            callback: () => {},
        })
    }, []);

    return (
        <Grid container className={styles.container} ref={componentRef}>
            {dimensions.width !== 0 && dimensions.height !== 0 && <Confetti
                width={dimensions.width}
                height={dimensions.height}
                gravity={0.05}
                recycle={true}
                numberOfPieces={1000}
            />}
            <Grid item xs={12} lg={6} className={styles.item}>
                <img src={kozel_meeet} alt={'kozel_meeet'} className={styles.logo} style={{maxWidth: '400px'}}/>
            </Grid>
            <Grid item xs={12} lg={6} className={styles.item}>
                <Typography className={styles.motoText}>There's always room for one more!</Typography>
            </Grid>
            <Grid item xs={12} lg={6} className={clsx(styles.item, styles.wrapperTeaserFrame)}>
                <TeaserFrame2
                    title={<Typography className={styles.teaserFrameTitle}>GOATIFUL!</Typography>}
                    backgroundBoxTitle={theme.colors.dark_chocolate}
                    titleMarginTop={'min(-5vh,-5vw)'}
                >
                    <Grid container className={styles.teaserContainer}>
                        <Grid item xs={12} className={styles.teaserItem}>
                            <Typography className={styles.teaserTitle}>CONGRATULATIONS FOR PARTICIPATING IN THE KOZEL MEET CHALLENGES!</Typography>
                        </Grid>
                        <Grid item xs={12} className={styles.teaserItem} flexDirection={'column'}>
                            <Typography className={styles.teaserText}>
                                We are sure you had a great time with your team and new friends!
                            </Typography>
                            <Typography className={styles.teaserText}>
                                <b>In KOZEL MEEET, everyone is a winner! The grand prize is the sheer fun and the HUGE connection you've created during the challenges!</b>
                            </Typography>
                            <Typography className={styles.teaserText}>
                                To celebrate the completion of the challenges, the teamwork and the connections made here, we invite you to the Kozel Meeet House where you have a cold beer to enjoy together!
                            </Typography>
                        </Grid>
                    </Grid>
                </TeaserFrame2>
            </Grid>
            <Grid item xs={12} lg={4} className={styles.item}>
                <Typography className={styles.barAccessText}>To access the bar, show this message to the brand ambassador.</Typography>
            </Grid>
            <Grid item xs={12} lg={4} className={styles.item}>
                <Typography className={styles.messageCzech}>Na zdraví!</Typography>
            </Grid>
            <Grid item xs={12} lg={4} className={styles.item}>
                <img src={image_mixologist} alt={'image_mixologist'} className={styles.imgMixologist} />
            </Grid>
            <Grid item xs={12} lg={6} className={styles.item}>
                <img src={kozel_meeet} alt={'kozel_meeet'} className={styles.logo} style={{maxWidth: '400px'}}/>
            </Grid>
            <Grid item xs={12} lg={6} className={styles.item}>
                <Typography className={styles.motoText}>There's always room for one more!</Typography>
            </Grid>
        </Grid>
    )
}

export default ChallengeFinal;